import node from './node'
import atlas from './image'
import particle from './particle'
import { captureCurrentScene } from './capture-scene'
import dragonBone from './dragon-bone'
import drawLine from './draw-line'
import box2d from './box2d'
import carousel from './carousel'
export default {
  ...node,
  ...carousel,
  ...atlas,
  ...particle,
  ...dragonBone,
  ...drawLine,
  ...box2d,
  captureCurrentScene,
}
